import ImageUploadButton from "./ImageUploadButton";
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ViewAsUserDropdown from "./ViewAsUserDropdown";
//class="small-padding full-height flex v-center dark-hoverable round-corners dark-active">
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import AddPhoto from './svg/AddPhoto.svg';
import A from './ActionCreators.js';
import { useDispatch } from 'react-redux';

export default function FilesystemController(){

  const dispatch = useDispatch();

  return (
    <div style={{

      //border:'3px solid blue',
    }} class="sg-row h-center v-center small-padding">



      


        <ImageUploadButton/>

    {true && <div button="create-directory" style={{
          background:'#f4f4f4',
          borderRadius:25,
          height:45,
          display:'flex',
          alignItems:'center',
      //border:'3px solid lime',
        }}
          onClick={() => {
            dispatch(A.createItem({
              itemType:"directories",
              inTopLevelParent:"imageSets"
            }))
          }}
          class="small-padding full-height flex v-center dark-hoverable round-corners dark-active">

          <CreateNewFolderIcon />
        </div>}

        {false && <div style={{
          position:'absolute',
          top:0,
          right:0,
          transform:'translate(50%,-50%)',
          zIndex:10000000,
        }}>
        <Tooltip title={"Hide Filesystem Window"}>
          <ArrowBackIosIcon style={{
            //fontSize:18,
            padding:0,
            margin:0,
            paddingLeft:5,
          }}/>

        </Tooltip>
        </div>}



        


    </div>
  )
}
